module.exports = __webpack_public_path__ + "static/media/estrella-tostada.9a13f1df.png";